module.exports = __webpack_public_path__ + "static/img/banner2.1821809b.svg";